import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";

/**
 * Fires /api/track-visit on every public route change.
 * Uses a browser session id so returning visitors can be deduped.
 */
const VisitTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Skip admin/login paths — analytics only tracks public
        if (location.pathname.startsWith("/admin") || location.pathname === "/login") return;

        let sid = window.sessionStorage.getItem("dimbani_sid");
        if (!sid) {
            sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
            window.sessionStorage.setItem("dimbani_sid", sid);
        }
        axios
            .post(`${API}/track-visit`, {
                path: location.pathname,
                session_id: sid,
                referrer: document.referrer || "",
            })
            .catch(() => {});
    }, [location.pathname]);

    return null;
};

export default VisitTracker;
